import { hasItemInSidebar } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/utils/index.tsx';
import type { SidebarConfigData } from '@atlassian/jira-navigation-types/src/types.tsx';
import type { Features } from '../../../common/types/index.tsx';

export const extractData = (
	data: SidebarConfigData,
	isDevMode: boolean,
	isAdmin: boolean,
): Features => ({
	hasGeneralConfiguration: isAdmin,
	hasDarkFeatures: hasItemInSidebar(data, 'dark_features'),
	hasTroubleshootingAndSupportSection: isAdmin,
	hasViewAuditing: isAdmin,
	hasPluginViewer: isDevMode && isAdmin,
	hasModulesViewer: isDevMode && isAdmin,
	hasSystemInfo: hasItemInSidebar(data, 'system_info'),
	hasIntegrityChecker: hasItemInSidebar(data, 'integrity_checker'),
	hasLoggingProfiling: hasItemInSidebar(data, 'logging_profiling'),
	hasSchedulerDetails: hasItemInSidebar(data, 'scheduler_details'),
	hasSecuritySection: isAdmin,
	hasProjectRoles: isAdmin,
	hasGlobalPermissions: isAdmin,
	hasCollectors: isAdmin,
	hasUserInterfaceSection: isAdmin,
	hasUserDefaults: isAdmin,
	hasEditDefaultDashboard: isAdmin,
	hasLookAndFeel: isAdmin,
	hasPasAdmin: hasItemInSidebar(data, 'com.atlassian.pas:pas-admin-link-jira'),
	hasImportExportSection: isAdmin,
	hasBackupManager: isAdmin,
	hasExternalImport: isAdmin,
	hasRestoreSystem: hasItemInSidebar(data, 'vertigo_import'),
	hasCloudImport: hasItemInSidebar(data, 'vertigo_import_jira_cloud'),
	hasServerImport: hasItemInSidebar(data, 'vertigo_import_jira_server'),
	hasMailSection: isAdmin,
	hasGlobalMailSettings: isAdmin,
	hasOutgoingMail: isAdmin,
	hasIncomingMail: isAdmin,
	hasSendMail: isAdmin,
	hasAdminHelperSection: isAdmin,
	hasPermissionHelper: isAdmin,
	hasSharedSection: isAdmin,
	hasManageDashboards: isAdmin,
	hasManageFilters: isAdmin,

	// advanced
	hasAdvancedSection: isAdmin,
	hasAttachments: isAdmin,
	hasEvents: isAdmin,
	hasWebHooks: isAdmin,
	hasServices: isAdmin,
	hasLexoRankManagement: hasItemInSidebar(data, 'greenhopper-lexorank-manage'),
});
